// src/components/Footer.js

import React from "react";
import { Box, Typography, Link } from "@mui/material";

function Footer() {
  return (
    <Box
      component="footer"
      sx={{
        mt: 4,
        py: 2,
        textAlign: "center",
        borderTop: 1,
        borderColor: "divider",
        bgcolor: "background.paper",
      }}
    >
      <Typography variant="body2" color="text.secondary">
        &copy; {new Date().getFullYear()} marcaki. Todos os direitos reservados.
      </Typography>

      {/* Links de navegação no footer */}
      <Box sx={{ mt: 1 }}>
        <Link href="/" color="inherit" sx={{ mx: 1 }}>
          Home
        </Link>
        <Link href="/user/home" color="inherit" sx={{ mx: 1 }}>
          Serviços
        </Link>
        <Link href="https://wa.me/5511980896777" color="inherit" sx={{ mx: 1 }}>
          Contato
        </Link>
      </Box>
    </Box>
  );
}

export default Footer;
